
<ul>
    @for( post of data; track $index) {
        <li><a [routerLink]="getNavRoute(post)">{{post.title}}</a></li>
    }
</ul>
